import type { FeatureName } from '~/shared/feature-flag-service/feature-flag-service';

// The strategy builds on the Position Architecture, so it needs Position Management's flag besides its own.
const strategyFeatureFlags: readonly FeatureName[] = ['co-studio-workspace', 'position-management-v-2'];

/** Whether the AI transformation entry shows the strategy instead of the opportunity map. */
export const isAiTransformationStrategyReleased = (isFeatureFlagEnabled: (name: FeatureName) => boolean): boolean =>
    strategyFeatureFlags.every(isFeatureFlagEnabled);
